import React, { useState } from 'react';
import { PageHeader, Card, FormGroup, Input, Select, Button, DataTable, Badge, Tabs } from '../../components/common/UIComponents';
import { ReceiptsController, PaymentsController, JVController, PendingApprovalController } from '../../controllers';

const instrumentTypes = ['CHO', 'NEFT', 'Cash', 'ODD', 'IMPS', 'OUP'];
const banks = ['BANK OF INDIA--002052363252111', 'HDFC BANK--678987672', 'CASH'];
const members = ['F0101 - Anuj Sharma', 'F0102 - Abhishek Singh', 'F0103 - Ravi Kumar', 'F0201 - Meena Patel', 'F0204 - kolambe sir'];

function ReceiptsTab() {
  const [records] = useState([]);
  const [member, setMember] = useState('');
  const [amount, setAmount] = useState('');
  const [instrumentType, setInstrumentType] = useState('Cash');
  const [bank, setBank] = useState('');
  const [receiptDate, setReceiptDate] = useState('');
  const [filter, setFilter] = useState('Both');

  const columns = [
    { key: 'unit', label: 'Unit' },
    { key: 'amount', label: 'Amount', render: r => <span className="td-amount credit">₹{r.amount?.toLocaleString('en-IN')}</span> },
    { key: 'bank', label: 'Bank' },
    { key: 'chqNo', label: 'Chq No', className: 'td-mono' },
    { key: 'chqDate', label: 'Chq Dated' },
    { key: 'receiptDate', label: 'Receipt Dated' },
    { key: 'depositBank', label: 'Deposit Bank' },
    { key: 'recNo', label: 'Rec No', className: 'td-mono' },
    { key: 'cleared', label: 'Clear' },
    { key: 'print', label: 'Print', render: () => <Button size="sm">Print</Button> },
    { key: 'log', label: 'View Log', render: () => <Button size="sm" variant="secondary">Log</Button> },
  ];

  return (
    <div>
      <Card style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Select Member"><Select value={member} onChange={e => setMember(e.target.value)} options={members} placeholder="Select" /></FormGroup>
          <FormGroup label="Payment Amount" required><Input type="number" placeholder="Enter Payment Amount" value={amount} onChange={e => setAmount(e.target.value)} /></FormGroup>
          <FormGroup label="Tick for Manual"><label className="checkbox-label"><input type="checkbox" /> Manual</label></FormGroup>
        </div>
        <div style={{ marginBottom: 10 }}>
          <div className="form-label" style={{ marginBottom: 6 }}>Instrument Type</div>
          <div className="radio-group">
            {instrumentTypes.map(t => <label key={t} className="radio-label"><input type="radio" name="instrType" checked={instrumentType === t} onChange={() => setInstrumentType(t)} /> {t}</label>)}
          </div>
        </div>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Cash and Bank A/C"><Select value={bank} onChange={e => setBank(e.target.value)} options={banks} placeholder="Select" /></FormGroup>
          <FormGroup label="Receipt Date" required><Input type="date" value={receiptDate} onChange={e => setReceiptDate(e.target.value)} /></FormGroup>
          <FormGroup label="Voucher No"><Input type="number" defaultValue="17" /></FormGroup>
        </div>
        <div style={{ marginBottom: 12 }}>
          <div className="form-label" style={{ marginBottom: 6 }}>Filter</div>
          <div className="radio-group">
            {['Filter Bank Wise', 'Filter Date Wise', 'Filter Receipt No Wise'].map(t => <label key={t} className="radio-label"><input type="radio" name="filterType" /> {t}</label>)}
          </div>
          <div className="radio-group" style={{ marginTop: 6 }}>
            {['Regular', 'Supplementary', 'Both'].map(t => <label key={t} className="radio-label"><input type="radio" name="filterCat" checked={filter === t} onChange={() => setFilter(t)} /> {t}</label>)}
          </div>
        </div>
        <div className="form-grid form-grid-2" style={{ marginBottom: 14 }}>
          <FormGroup label="From Date"><Input type="date" defaultValue="2025-04-01" /></FormGroup>
          <FormGroup label="To Date"><Input type="date" defaultValue="2026-02-01" /></FormGroup>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button>Search</Button>
          <Button variant="amber" style={{ background: '#d97706', color: '#fff' }}>Print</Button>
          <Button variant="secondary">Send Mails</Button>
          <Button variant="secondary">Send SMS</Button>
          <Button variant="secondary">Refresh</Button>
          <Button variant="secondary">Export</Button>
          <Button variant="secondary">Posted Receipts</Button>
          <Button variant="secondary">Approved Receipts</Button>
          <Button variant="secondary">Reserial Receipt Nos.</Button>
        </div>
      </Card>
      <DataTable title="Receipt Details" columns={columns} data={records} onSearch={() => records} />
    </div>
  );
}

function PaymentsTab() {
  const [records] = useState(PaymentsController.getAll());
  const [payType, setPayType] = useState('Direct Payments');
  const expenses = ['Guard Salary Expenses', 'CCTV Camera', 'Water Tanker Charges', 'Salary', 'Tele Phone Expenses'];

  const columns = [
    { key: 'expense', label: 'Expense' },
    { key: 'amount', label: 'Amount', render: r => <span className="td-amount debit">₹{r.amount?.toLocaleString('en-IN')}</span> },
    { key: 'vouDate', label: 'Vou. Date' },
    { key: 'vouNo', label: 'Vou. No', className: 'td-mono' },
    { key: 'cheque', label: 'Cheque', className: 'td-mono' },
    { key: 'paid', label: 'Paid' },
    { key: 'account', label: 'Account' },
    { key: 'cleared', label: 'Cleared', render: r => <Badge color={r.cleared === 'Not Clear' ? 'red' : 'green'}>{r.cleared}</Badge> },
    { key: 'print', label: 'Print', render: () => <Button size="sm">Print</Button> },
    { key: 'log', label: 'View Log', render: () => <Button size="sm" variant="secondary">Log</Button> },
  ];

  return (
    <div>
      <Card style={{ marginBottom: 20 }}>
        <div className="radio-group" style={{ marginBottom: 14 }}>
          {['Direct Payments', 'Vendor Payments'].map(t => <label key={t} className="radio-label"><input type="radio" checked={payType === t} onChange={() => setPayType(t)} /> {t}</label>)}
        </div>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Party Name"><Input placeholder="Enter Party Name" /></FormGroup>
          <FormGroup label="Voucher No"><Input type="number" defaultValue="112" /></FormGroup>
          <FormGroup label="Voucher Date"><Input type="date" /></FormGroup>
          <FormGroup label="Bill No"><Input placeholder="Enter Bill No" /></FormGroup>
          <FormGroup label="Expense type"><Select options={expenses} placeholder="Select" /></FormGroup>
          <FormGroup label="Amount"><Input type="number" /></FormGroup>
          <FormGroup label="TDS(%)"><Input type="number" defaultValue="0" /></FormGroup>
          <FormGroup label="Cash Bank"><Select options={banks} placeholder="BANK OF INDIA" defaultValue="BANK OF INDIA--002052363252111" /></FormGroup>
          <FormGroup label="Cheque Date"><Input type="date" /></FormGroup>
          <FormGroup label="Cheque No"><Input placeholder="Enter Cheque No" /></FormGroup>
          <FormGroup label="Cleared on"><Input type="date" /></FormGroup>
          <FormGroup label="Narration"><Input placeholder="Enter Narration" /></FormGroup>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button variant="secondary">Refresh</Button>
          <Button variant="secondary">Export</Button>
          <Button variant="secondary">Expense Report</Button>
          <Button variant="secondary">Vendor Report</Button>
          <Button variant="secondary">General Leger</Button>
          <Button variant="secondary">Reserial Voucher Nos</Button>
        </div>
      </Card>
      <DataTable title="Expenses Details" columns={columns} data={records} onSearch={() => records} />
    </div>
  );
}

function GeneralReceiptsTab() {
  const [records] = useState([{ id: 1, vendor: 'old bicycle sold', income: 'old bicycle sold', amount: 1060.00, dated: '09-05-2025', no: 1, bank: 'CASH', deposit: '09-05-2025', clear: '09-05-2025' }]);
  const incomes = ['Society Mobile Tower Rent Received', 'Interest from Fixed Deposit', 'old bicycle sold'];

  const columns = [
    { key: 'vendor', label: 'Vendor/Party' },
    { key: 'income', label: 'Income' },
    { key: 'amount', label: 'Amount', render: r => <span className="td-amount credit">₹{r.amount?.toLocaleString('en-IN')}</span> },
    { key: 'dated', label: 'Dated' },
    { key: 'no', label: 'No', className: 'td-mono' },
    { key: 'bank', label: 'Bank' },
    { key: 'deposit', label: 'Deposit' },
    { key: 'clear', label: 'Clear' },
    { key: 'print', label: 'Print', render: () => <Button size="sm">Print</Button> },
    { key: 'log', label: 'View Log', render: () => <Button size="sm" variant="secondary">Log</Button> },
  ];

  return (
    <div>
      <Card style={{ marginBottom: 20 }}>
        <div className="radio-group" style={{ marginBottom: 14 }}>
          {['General Receipts', 'Vendor Receipts'].map(t => <label key={t} className="radio-label"><input type="radio" defaultChecked={t === 'General Receipts'} /> {t}</label>)}
        </div>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Voucher Date"><Input type="date" /></FormGroup>
          <FormGroup label="Voucher No"><Input type="number" defaultValue="2" /></FormGroup>
          <FormGroup label="Select Income"><Select options={incomes} placeholder="Select" /></FormGroup>
          <FormGroup label="Total Income Amount"><Input type="number" /></FormGroup>
          <FormGroup label="SGst(%)"><Input type="number" defaultValue="0" /></FormGroup>
          <FormGroup label="CGst(%)"><Input type="number" defaultValue="0" /></FormGroup>
          <FormGroup label="TDS(%)"><Input type="number" defaultValue="0" /></FormGroup>
          <FormGroup label="Instrument Type">
            <div className="radio-group">
              {['Cheque', 'NEFT', 'IMPS', 'OUP', 'Cash'].map(t => <label key={t} className="radio-label"><input type="radio" name="giType" defaultChecked={t === 'Cheque'} /> {t}</label>)}
            </div>
          </FormGroup>
          <FormGroup label="Cash and Bank A/C"><Select options={banks} placeholder="select" /></FormGroup>
          <FormGroup label="Vendor / Party"><Input placeholder="Enter Vendor/Party Name" /></FormGroup>
          <FormGroup label="Narration"><Input placeholder="Enter Narration" /></FormGroup>
          <FormGroup label="Remarks"><Input placeholder="Enter Remarks" /></FormGroup>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button variant="secondary">Refresh</Button>
          <Button variant="secondary">Export</Button>
          <Button variant="secondary">Income Report</Button>
          <Button variant="secondary">General Leger</Button>
          <Button variant="secondary">Reserial Voucher Nos</Button>
        </div>
      </Card>
      <DataTable title="Income Details" columns={columns} data={records} onSearch={() => records} />
    </div>
  );
}

function ContraTab() {
  return (
    <div>
      <Card style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Source Account"><Select options={banks.map(b => b.split('--')[0])} placeholder="Select" /></FormGroup>
          <FormGroup label="Destination Account"><Select options={banks.map(b => b.split('--')[0])} placeholder="Select" /></FormGroup>
          <FormGroup label="Instrument Type">
            <div className="radio-group">
              {['Cheque', 'NEFT', 'Cash', 'DD'].map(t => <label key={t} className="radio-label"><input type="radio" name="contraType" defaultChecked={t === 'Cheque'} /> {t}</label>)}
            </div>
          </FormGroup>
          <FormGroup label="Amount"><Input type="number" placeholder="Enter Amount" /></FormGroup>
          <FormGroup label="Instrument Number"><Input placeholder="Enter Instrument Number" /></FormGroup>
          <FormGroup label="Cheque Date"><Input type="date" /></FormGroup>
          <FormGroup label="Deposit Date"><Input type="date" /></FormGroup>
          <FormGroup label="Cleared on"><Input type="date" /></FormGroup>
          <FormGroup label="Narration"><Input placeholder="Enter Narration" /></FormGroup>
          <FormGroup label="Withdrawn by"><Input placeholder="Enter Withdrawn by" /></FormGroup>
          <FormGroup label="Voucher No"><Input type="number" defaultValue="2" /></FormGroup>
        </div>
        <Button variant="secondary">Refresh</Button>
      </Card>
    </div>
  );
}

function JVTab() {
  const [records] = useState(JVController.getAll());
  const ledgers = ['discount', 'amitva', 'bhoomif0102', 'JIO Billing sohail', 'Salary', 'Water Charges'];

  const columns = [
    { key: 'id', label: '#' },
    { key: 'jvNo', label: 'JV No', className: 'td-mono' },
    { key: 'debitLedger', label: 'Debit Ledger' },
    { key: 'creditLedger', label: 'Credit Ledger' },
    { key: 'amount', label: 'Amount', render: r => <span className="td-amount">₹{r.amount?.toLocaleString('en-IN')}</span> },
    { key: 'date', label: 'Date' },
    { key: 'actions', label: 'Print JV / View Log', render: () => (
      <div style={{ display: 'flex', gap: 4 }}>
        <Button size="sm">Print JV</Button>
        <Button size="sm" variant="secondary">Log</Button>
      </div>
    )},
  ];

  return (
    <div>
      <Card style={{ marginBottom: 20 }}>
        <div className="radio-group" style={{ marginBottom: 12 }}>
          {['Single (Debit Note/Credit Note/JV)', 'Multiple Ledgers JV'].map(t => <label key={t} className="radio-label"><input type="radio" name="jvType" defaultChecked={t.includes('Single')} /> {t}</label>)}
        </div>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Debit Ledger"><Select options={ledgers} placeholder="Select" /></FormGroup>
          <FormGroup label="Credit Ledger"><Select options={ledgers} placeholder="Select" /></FormGroup>
          <FormGroup label="Amount"><Input type="number" placeholder="Enter Amount" /></FormGroup>
          <FormGroup label="JV Date"><Input type="date" /></FormGroup>
          <FormGroup label="Narration"><Input placeholder="Enter Remarks" /></FormGroup>
          <FormGroup label="JV No"><Input type="number" defaultValue="6" /></FormGroup>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button variant="secondary">Refresh</Button>
          <Button variant="secondary">JV Report</Button>
        </div>
      </Card>
      <DataTable title="JV Details" columns={columns} data={records} onSearch={() => records} />
    </div>
  );
}

function ApproveReceiptsTab() {
  const [records] = useState(PendingApprovalController.getAll());

  const columns = [
    { key: 'flatNo', label: 'Flat No' },
    { key: 'name', label: 'Name' },
    { key: 'refNo', label: 'Ref No', className: 'td-mono' },
    { key: 'dated', label: 'Dated' },
    { key: 'bank', label: 'Bank' },
    { key: 'amount', label: 'Amount', render: r => <span className="td-amount credit">₹{r.amount?.toLocaleString('en-IN')}</span> },
    { key: 'deposit', label: 'Deposit', render: () => <Select options={['Bank of India', 'HDFC', 'Cash']} placeholder="Select" /> },
    { key: 'type', label: 'Type', render: r => <Badge color="amber">{r.type}</Badge> },
  ];

  return (
    <div>
      <DataTable title="Receipts Pending for Approval" columns={columns} data={records} onSearch={() => records} />
    </div>
  );
}

const tabList = [
  { id: 'receipts', label: 'Receipts' },
  { id: 'payments', label: 'Payments' },
  { id: 'general', label: 'General Receipts' },
  { id: 'contra', label: 'Contra' },
  { id: 'jv', label: 'Debit Note/Credit Note/JV' },
  { id: 'approve', label: 'Approve Receipts 🔴' },
];

export default function TransactionPage() {
  const [activeTab, setActiveTab] = useState('receipts');

  const tabContent = {
    receipts: <ReceiptsTab />,
    payments: <PaymentsTab />,
    general: <GeneralReceiptsTab />,
    contra: <ContraTab />,
    jv: <JVTab />,
    approve: <ApproveReceiptsTab />,
  };

  return (
    <div className="fade-in">
      <PageHeader title="Transaction" description="Manage all financial transactions" />
      <Tabs tabs={tabList} active={activeTab} onChange={setActiveTab} />
      {tabContent[activeTab]}
    </div>
  );
}
